package com.kinoshazam

import kotlin.Boolean
import kotlin.Int
import kotlin.OptIn
import kotlin.String
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport

@JsExport
@OptIn(ExperimentalJsExport::class)
public object BuildKonfig {
  public val APP_ID: String = "com.kinoshka"

  public val APP_NAME: String = "Kinoshka"

  public val URL_PATH: String = "api/v1/"

  public val LOCAL_PORT: Int = 8080

  public val PROD_HOST: String = "api.kinoshka.net"

  public val ENABLE_NETWORK_LOGS: Boolean = false

  public val IS_LOCAL: Boolean = false

  public val LOCAL_HOST_OVERRIDE: String = ""
}
